import { render, staticRenderFns } from "./AnalysisDetails.vue?vue&type=template&id=5092c036&scoped=true&"
import script from "./AnalysisDetails.vue?vue&type=script&lang=js&"
export * from "./AnalysisDetails.vue?vue&type=script&lang=js&"
import style0 from "./AnalysisDetails.vue?vue&type=style&index=0&id=5092c036&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5092c036",
  null
  
)

export default component.exports